export default __webpack_public_path__ + "fc29044b596272d5c56eb6e040d4b6a8.png";